<template>
  <div class="main-page">
    <section class="page-section">
      <div
        class="grid justify-content-center p-2 lg:p-0"
        style="min-width: 80%"
      >
        <div
          class="col-12 xl:col-6"
          style="
            border-radius: 56px;
            padding: 0.3rem;
            background: linear-gradient(
              180deg,
              rgba(233, 0, 0, 0.8) 10%,
              rgba(233, 0, 0, 0) 30%
            );
          "
        >
          <div
            class="flex justify-content-center h-full w-full m-0 py-4 px-4"
            style="
              border-radius: 53px;
              background: linear-gradient(
                180deg,
                var(--surface-50) 38.9%,
                var(--surface-0)
              );
            "
          >
            <div class="grid flex-column align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 1"
                width="250"
                height="200"
                viewBox="0 0 540 797.97143"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <polygon
                  points="362.06 702.184 125.274 702.184 125.274 700.481 360.356 700.481 360.356 617.861 145.18 617.861 134.727 596.084 136.263 595.347 146.252 616.157 362.06 616.157 362.06 702.184"
                  fill="#2f2e41"
                />
                <circle
                  cx="156.78851"
                  cy="726.03301"
                  r="17.88673"
                  fill="#3f3d56"
                />
                <circle
                  cx="333.10053"
                  cy="726.03301"
                  r="17.88673"
                  fill="#3f3d56"
                />
                <circle
                  cx="540.92726"
                  cy="346.153"
                  r="11.07274"
                  fill="#3f3d56"
                />
                <path
                  d="M539.38538,665.76747H273.23673L215.64844,477.531H598.69256l-.34852,1.10753Zm-264.8885-1.7035H538.136l58.23417-184.82951H217.95082Z"
                  transform="translate(-152 -76.01429)"
                  fill="#2f2e41"
                />
                <polygon
                  points="366.61 579.958 132.842 579.958 82.26 413.015 418.701 413.015 418.395 413.998 366.61 579.958"
                  fill="#f2f2f2"
                />
                <polygon
                  points="451.465 384.7 449.818 384.263 461.059 341.894 526.448 341.894 526.448 343.598 462.37 343.598 451.465 384.7"
                  fill="#2f2e41"
                />
                <rect
                  x="82.2584"
                  y="458.58385"
                  width="345.2931"
                  height="1.7035"
                  fill="#2f2e41"
                />
                <rect
                  x="101.45894"
                  y="521.34377"
                  width="306.31852"
                  height="1.7035"
                  fill="#2f2e41"
                />
                <rect
                  x="254.31376"
                  y="402.36843"
                  width="1.7035"
                  height="186.53301"
                  fill="#2f2e41"
                />
                <rect
                  x="385.55745"
                  y="570.79732"
                  width="186.92877"
                  height="1.70379"
                  transform="translate(-274.73922 936.23495) rotate(-86.24919)"
                  fill="#2f2e41"
                />
                <rect
                  x="334.45728"
                  y="478.18483"
                  width="1.70379"
                  height="186.92877"
                  transform="translate(-188.46866 -52.99638) rotate(-3.729)"
                  fill="#2f2e41"
                />
            
              </svg>

              <div
                class="grid flex-column align-items-center py-5 border-300"
              >
              <div class="text-pink-500 font-bold text-2xl text-center"> {{ $t("caps_mall_is_temporarily_closed") }}</div>
            <span class="text-gray-600"
              >{{ $t("please_come_back_later") }}</span
            >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "capsmallClosedSvgPage",
  components: {},
};
</script>
